import React, { useState, useMemo, useRef } from 'react';

import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import useSinglePieCharts from '@/pages/intelligence/components/Chart/hooks/useSinglePieCharts';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import { DATA_SOURCE_NAME_MAP } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import type { IChartsIndexInstance } from '@intelligence/components/ChartsComponents/ChartsIndex';

const Visualis: React.FC<any> = (props: any) => {
  const {
    barOrPieData,
    middleTitle,
    chartType,
    imageType = 'mobile',
    dataSource,
    lineLegendsCustomMade,
    splitNumber = 4, // y轴显示个数
    isxLabelDate = true, //x轴label默认展示日期
    legendStyle = '',
    lineSeriesData,
    lineXAxisData,
    yAxisFormatter,
    dateType,
    startDate,
    endDate,
    pageId,
    getMetricTitle,
  } = props;

  // console.log('VisualisEditions',props);

  const cardRef = useRef(null);
  const chartsInstance = useRef<IChartsIndexInstance>(null);
  const [chartLoading, setChartLoading] = useState(false);

  const barNameList = useMemo(() => {
    return barOrPieData?.map((item: { name: any }) => item?.name) || [];
  }, [barOrPieData]);

  const barSeriesData = useMemo(() => {
    return barOrPieData?.map((item: any, i: number): any => ({
      type: 'bar',
      name: item.name,
      value: item.value ? item.value : 0,
      cover: item.cover,
      itemStyle: {
        color: ECHARTSCOLOR[i],
      },
      label: {
        show: true,
        position: 'top',
        color: '#444',
        distance: 4,
        fontSize: 12,
        formatter: (params: any) => `${newMathFormat(Number(params.value), true)}`,
      }
    }));
  }, [barOrPieData]);

  const dataSourceNames = useMemo(() => {
    if (!Array.isArray(dataSource) && dataSource == '') return [];
    if (Array.isArray(dataSource)) {
      return dataSource.map(item => DATA_SOURCE_NAME_MAP[item])
        .filter(item => item);
    } else if (dataSource != '') {
      return [DATA_SOURCE_NAME_MAP[dataSource]];
    }
  }, [dataSource]);

  // 获取柱状图hooks
  const {
    barOption,
  } = useBarCharts({
    seriesData: barSeriesData,
    setChartLoading,
    barOrPieData,
    titleNow: getMetricTitle(pageId, dateType),
    dataSourceEachers: dataSourceNames,
    barNameList,
    topChartsType: 'stats-activeuser-bar',
    cardWidth: cardRef?.current?.clientWidth,
    imageType,
    startDate,
    endDate,
  });

  // 获取饼图hooks
  const {
    pieOption
  } = useSinglePieCharts({
    pieData: barOrPieData,
    pieTitle: middleTitle,
    chartLoading,
    chartType,
    chartsInstance,
    titleNow: getMetricTitle(pageId, dateType),
    startDate,
    endDate,
  });


  // 获取折线图hooks
  const {
    lineOption
  } = useLineCharts({
    lineXAxisData, //x轴 label 数据
    lineSeriesData, // 折线 数据
    legendsCustomMade: lineLegendsCustomMade, // 图例
    yAxisFormatter, // y轴格式化函数
    splitNumber, // y轴显示个数
    isxLabelDate, //x轴label默认展示日期
    legendStyle,
    topChartsType: 'stats-activeuser-line',
    imageType,
    titleNow: getMetricTitle(pageId, dateType),
    dateType,
  });

  return (
    <>
      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          ref={chartsInstance}
          chartLoading={chartLoading}
          lineOption={lineOption}
          chartType={chartType}
          // isNodata={isNodata}
          pieOption={pieOption}
          barOption={barOption}
        />
      </div>
    </>
  );
};

export default Visualis;
